































import axios from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    backImage: {
      type: String,
      default: require("@/assets/images/vintageBarberWall.jpg")
    },
    pingBackend: {
      type: Boolean,
      default: false
    }
  }
})
export default class BarberPage extends Vue {
  private pingBackend!: boolean;

  private async selectBarber(barberName: string) {
    this.pingBackend = true;
    await axios
      .get(process.env.VUE_APP_GEMERBARBIER_API, { timeout: 30000 })
      .then(() => {
        this.pingBackend = false;
        this.$store.commit("setBarberMenu", barberName);
        this.$router.push({ name: "calendar" });
      });
  }
}
